import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket";
import type { CaseRecord } from "@/features/case-record/types/case-records";
import { ScrollArea } from "@radix-ui/react-scroll-area";
import { IconDatabaseExclamation } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { caseEvidenceListCategoryByTypeQueryOptions } from "../api/queries/category-query";
import EvidenceList from "./evidence-list";

export default function CaseEvidenceCategoryByTypeDisplayModal({
	category,
	evidenceType,
	parties,
	caseData,
}: { category: string; evidenceType: string; parties: string; caseData: CaseRecord }) {
	const categoryByTypeQuery = useQuery(
		caseEvidenceListCategoryByTypeQueryOptions({
			category_value: category,
			evidence_type: evidenceType,
		}),
	);
	const categoryByType = categoryByTypeQuery.data;

	return (
		<div className="flex flex-col w-full h-full">
			<div className="flex shrink grow flex-col w-full h-full">
				<ScrollArea className="flex flex-col w-full">
					{categoryByType?.data.length !== 0 ? (
						<div className="flex flex-col w-full">
							{evidenceType !== "Testimonial" ? (
								<EvidenceList
									displayOnly={true}
									className="flex flex-col w-full gap-2 overflow-y-auto"
									schema={[
										{
											className: "w-[90px] py-2 px-3 text-left text-sm text-foreground-dark",
											name: "evidence_attachment",
											label: "File Name",
											type: "dragged_file",
										},
										{
											name: "exhibit",
											label: "Exhibit",
											type: "text_input",
										},
										{
											name: "description",
											label: "Description",
											type: "textarea",
										},
										{
											name: "purpose",
											label: "Purpose",
											type: "textarea",
										},
										{
											name: "marking_status",
											label: "Marking Status",
											type: "marking_status",
										},
										{
											name: "admission_status",
											label: "Admission Status",
											type: "admission_status",
										},
										{
											name: "category",
											label: "Category",
											type: "textarea",
										},
									]}
									data={categoryByType?.data.map((data) => {
										return {
											...data,
											file: data.evidence,
										};
									})}
									metadata={{
										evidence_type: evidenceType,
										parties: parties,
									}}
									caseData={caseData}
								/>
							) : (
								<EvidenceList
									className="flex flex-col w-full gap-2 overflow-y-auto"
									displayOnly={true}
									schema={[
										{
											className: "w-[90px] py-2 px-3 text-left text-sm text-foreground-dark",
											name: "evidence_attachment",
											label: "File Name",
											type: "dragged_file",
										},
										{
											name: "exhibit",
											label: "Exhibit",
											type: "text_input",
											placeholder: "Enter exhibit",
										},
										{
											name: "description",
											label: "Description",
											type: "textarea",
											placeholder: "Enter description",
										},
										{
											name: "purpose",
											label: "Purpose",
											type: "textarea",
											placeholder: "Enter purpose",
										},
										{
											name: "marking_status",
											label: "Marking Status",
											type: "marking_status",
										},
										{
											name: "admission_status",
											label: "Admission Status",
											type: "admission_status",
										},
										{
											name: "category",
											label: "Category",
											type: "textarea",
											placeholder: "Enter category",
										},
									]}
									data={categoryByType?.data.map((data) => {
										return {
											...data,
											file: data.evidence,
										};
									})}
									metadata={{
										evidence_type: evidenceType,
										parties: parties,
									}}
									caseData={caseData}
								/>
							)}
						</div>
					) : (
						<Blanket width="sm">
							<BlanketImage icon={<IconDatabaseExclamation size={24} stroke={1.5} />} />
							<BlanketInfo title="No Data" message="No available data for now. Please check back later or refresh the page." />
						</Blanket>
					)}
				</ScrollArea>
			</div>
		</div>
	);
}
